import React, { useState, useRef, useEffect } from "react";
import "./Signup.scss";
import "./Welcome.scss";
import { useHistory, useLocation } from "react-router-dom";
import db from "../utils/firebase";
import { useStateValue } from "../context/StateProvider";
import { useQuery } from "../utils/scrollToTop";
import { getCartTotal, getTotalItems } from "../context/reducer";
    
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

const stripePromise = loadStripe(
  "pk_test_51JMqiUSEYRydvZDnl4tJt29ouEIo2URpHsTMPwKCUAPFsEbz2pWIFQtVek1jgKmPl6rV0IFjPKeSGN9tGokt8VEC00SxkkoTDJ"
);

function ConfirmAddress() {
  const query = useQuery();
  const history = useHistory();
  const checkbox = useRef(null);
  const [address, setAddress] = useState("");
  const [username, setUsername] = useState("");
  const [stateName, setStateName] = useState("");
  const [country] = useState("India");
  const [zipcode, setZipcode] = useState("");
  const [phone, setPhone] = useState("");
  const [checked, setChecked] = useState(false);
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [{ user, cart, loadingBar }, dispatch] = useStateValue();

  const validateNumber = (value) => {
    const re = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    return re.test(value);
  };
  useEffect(() => {
    if (user) {
      db.collection("users")
        .doc(user.uid)
        .get()
        .then((snapshot) => {
          if (snapshot.exists) {
            let { address, state, postal_code, phone, name } = snapshot.data();
            setUsername(name);
            setAddress(address);
            setStateName(state);
            setZipcode(postal_code);
            setPhone(phone);
          } else {
            history.replace("/welcome?next=payment", { update: true });
          }
        });
    }
  }, [user, history]);
  const createCheckoutSession = async () => {
    const stripe = await stripePromise;
    const productDetails = cart.map((e) => ({
      id: e.id,
      quantity: e.quantity,
    }));
    const { data } = await axios.post(
      "https://florakart.herokuapp.com/api/create-checkout-session",
      {
        productDetails,
        email: "email",
      }
    );

    const result = await stripe.redirectToCheckout({
      sessionId: data.id,
    });
    if (result.error) {
      console.log("payment failed");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (country && validateNumber(phone) && checked) {
      setStatus(true);
      //   loadingBar.current.continuousStart();
      createCheckoutSession();
    } else {
      alert("Please check your details again!");
    }
  };

  return (
    <div className="welcome">
      <div className="welcome__header">
        <img className="welcome__avatar" src={user?.photoURL} alt="" />
        <span>
          <h3>Confirm and Pay</h3>
          <p style={{ maxWidth: "480px", marginBottom: "2rem", opacity: 0.5 }}>
            We need you to update some of your shipping and contact details.
          </p>
        </span>
      </div>
      <div className="welcome__inner">
        <form className="form__split" onSubmit={(e) => handleSubmit(e)}>
          <div className="form">
            <h5>Delivery Address</h5>
            <div className="form__element">
              <input
                className={username ? "active " : ""}
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <label for="username">Name</label>
            </div>
            <div className="form__element">
              <input
                className={address ? "active " : ""}
                id="address"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
              <label for="address">Address</label>
            </div>
            <div className="form__element">
              <input
                className={stateName ? "active " : ""}
                id="state"
                type="text"
                value={stateName}
                onChange={(e) => setStateName(e.target.value)}
                required
              />
              <label for="state">State</label>
            </div>
            <div className="form__element">
              <input
                className={country ? "active " : ""}
                id="country"
                type="text"
                value={country}
                required
              />
              <label for="state">Country</label>
            </div>
            <div className="form__element">
              <input
                className={zipcode ? "active " : ""}
                id="zip"
                type="text"
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
                required
              />
              <label for="zip">ZIP Code</label>
            </div>
          </div>
          <div className="form">
            <h5>Personal Details</h5>

            <div className="form__element">
              <input
                className={phone ? "active " : ""}
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <label for="phone">Mobile Number</label>
            </div>
            <div className="form__element">
              <input
                id="terms"
                type="checkbox"
                ref={checkbox}
                checked={checked}
                required
              />
              <label
                onClick={() => setChecked((checked) => !checked)}
                for="terms"
              >
                It's the delivery address
              </label>
            </div>
            <div>
              <p className="cart__total">Sub-Total: ₹{getCartTotal(cart)}</p>
              <p>Number of items: {getTotalItems(cart)}</p>
            </div>
            <div className="form__element buttons">
              <button
                disabled={!checked || loading}
                style={{ margin: "none" }}
                className="button buttonPrimary submit"
                type="submit"
              >
                {status ? "Payment Page..." : "Pay"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default ConfirmAddress;
